import React from 'react';
import Isvg from 'react-inlinesvg';
import { withRouter } from 'react-router-dom';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import CrossIcon from 'app/images/icons/cross.svg';

interface IFullModalProps {
  children: React.ReactNode;
  isModal: boolean;
  history: any;
  match: any;
}
class FullModal extends React.Component<IFullModalProps> {
  modalRef;

  constructor(props) {
    super(props);
    this.modalRef = React.createRef();
  }

  componentDidMount(): void {
    const { isModal } = this.props;

    if (isModal) {
      disableBodyScroll(this.modalRef.current);
    }
  }

  componentWillUnmount(): void {
    enableBodyScroll(this.modalRef.current);
  }

  render(): React.ReactNode {
    const { id } = this.props.match.params;
    const previousPath = this.props.match?.previousPath?.split('\\::')[0];
    if (this.props.isModal) {
      return (
        <div
          ref={this.modalRef}
          className="full-modal-wrapper"
          onClick={(): void => this.props.history.push(previousPath)}
        >
          <div className="full-modal" onClick={(e): void => e.stopPropagation()}>
            <a onClick={(): void => this.props.history.push(previousPath)} className="modal-close-button">
              <Isvg src={CrossIcon} className="modal-close-icon" />
            </a>

            {this.props.children}
          </div>
        </div>
      );
    }
    return (
      <div className="no-full-modal-wrapper">
        {this.props.children}
      </div>
    );
  }
}

export default withRouter(FullModal);
